import React from "react"
import { Dialog, DialogContent, Box, Stack, Button, useTheme, Divider } from "@mui/material"
import CustomAutocomplete from "src/components/CustomAutocomplete"
import { StatusOption, DataSourceOption } from "./DataSourcesFilter"
import { CloseModalIconButton } from "src/components/CloseModalIconButton"

interface DataSourcesFilterModalProps {
  open: boolean
  onClose: () => void
  statusFilter: StatusOption[]
  onStatusFilterChange: (statuses: StatusOption[]) => void
  statusOptions: StatusOption[]
  dataSourceFilter: DataSourceOption | undefined
  onDataSourceFilterChange: (dataSource: DataSourceOption) => void
  dataSourceOptions: DataSourceOption[]
}

const DataSourcesFilterModal: React.FC<DataSourcesFilterModalProps> = ({
  open,
  onClose,
  statusFilter,
  onStatusFilterChange,
  statusOptions,
  dataSourceFilter,
  onDataSourceFilterChange,
  dataSourceOptions
}) => {
  const theme = useTheme()

  const handleApplyFilters = () => {
    onClose()
  }

  const handleClearFilters = () => {
    onStatusFilterChange([])
    onDataSourceFilterChange(dataSourceOptions[0])
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableScrollLock
      fullScreen={true}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "0",
          backgroundColor: "#FAFAFA"
        }
      }}
    >
      <Stack direction="row" justifyContent="flex-end" alignItems="center" sx={{ p: theme.spacing(1, 1, 0, 0) }}>
        <CloseModalIconButton onClose={onClose} />
      </Stack>
      <DialogContent sx={{ p: 0 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 2 }}>
          <Box sx={{ fontSize: "1.5rem", fontWeight: 600, p: 2 }}>Filters</Box>
          <Button variant="outlined" onClick={handleClearFilters} color="secondary">
            Clear
          </Button>
        </Stack>
        <Divider sx={{ mb: 2 }} />
        <Stack spacing={3} alignItems="stretch" sx={{ p: 2 }}>
          {/* Status Filter */}
          <Box>
            <CustomAutocomplete<StatusOption>
              value={statusFilter}
              options={statusOptions}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.label === value.label}
              onChange={(e, val) => {
                onStatusFilterChange(val as StatusOption[])
              }}
              label="Status"
              size="medium"
              multiple
            />
          </Box>

          {/* Knowledge Base Filter */}
          <Box>
            <CustomAutocomplete<DataSourceOption>
              value={dataSourceFilter}
              options={dataSourceOptions}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              onChange={(e, val) => {
                onDataSourceFilterChange(val as DataSourceOption)
              }}
              label="Knowledge Base"
              size="medium"
              disableClearable
            />
          </Box>

          {/* Action Button */}
          <Stack spacing={2} sx={{ mt: 4 }}>
            <Button variant="contained" onClick={handleApplyFilters}>
              Search
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default DataSourcesFilterModal
